// Japan
export const locale = {
	lang: 'jp',
	data: {
		
	}
};
